<template>
  <div class="container pdf-report-vital-signs">
    <b-overlay class="mt-5" :show="loading" opacity="0.99">
      <div v-show="errors.length > 0">
        <ErrorsMessages :errors="errors" />
      </div>
      <div v-show="errors.length == 0">
        <div class="col-xl-12">
          <v-btn
            v-if="!loading"
            class="btn-print float-right"
            v-on:click="printOut"
            ><i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR</v-btn
          >
        </div>
        <table>
          <thead>
            <tr>
              <td>
                <div class="header-space">
                  <div v-if="resident.id" class="row">
                    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2">
                      <img
                        v-if="rest_home_logo_url"
                        class="rest_home_logo_url"
                        :src="rest_home_logo_url"
                      />
                      <div v-if="!rest_home_logo_url" class="ml-1">
                        <strong class="text-uppercase">{{
                          rest_home_name
                        }}</strong>
                      </div>
                    </div>
                    <div
                      class="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-7 d-flex align-items-center"
                    >
                      <img
                        v-if="resident.photo_url"
                        class="resident_photo_url"
                        :src="resident.photo_url"
                      />
                      <img
                        v-if="!resident.photo_url"
                        class="resident_photo_url"
                        :src="require('../../../../../assets/user.png')"
                      />
                      <div class="ml-5">
                        <h6 class="mb-0">
                          {{ resident.name }}
                        </h6>
                        <h6 class="mb-0 worksansr upper-text">
                          Data de nascimento:
                          {{ formatDate(resident.date_of_birth, false) }}
                          -
                          {{ getAge(resident.date_of_birth) }}
                          anos
                        </h6>
                        <h6 class="mb-0 worksansr upper-text">
                          Data de admissão:
                          {{ formatDate(resident.date_of_reception, false) }}
                        </h6>
                        <h6
                          class="mb-0 worksansr upper-text"
                          v-if="resident.bed_id"
                        >
                          Leito Nº: {{ resident.bed_number }}, Andar:
                          {{ resident.bed_walk }}, ALA/Setor:
                          {{ resident.bed_ward_or_sector }}, Quarto:
                          {{ resident.bed_bedroom }}
                        </h6>
                      </div>
                    </div>
                    <div
                      class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 d-flex align-items-center justify-content-end"
                    >
                      <img class="logo" :src="logo" width="180" />
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="content">
                  <table class="table table-sm bg-white">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                      <div
                        class="care"
                        v-for="(item, key) in cares"
                        :key="`${key}-${generateId()}`"
                      >
                        <div class="row">
                          <div
                            v-for="(item, key) in item.vital_signs"
                            :key="`${key}-${generateId()}`"
                            class="col-md-6 d-flex flex-column justify-content-center"
                          >
                            <div
                              v-for="vital_sign in item.vital_signs"
                              :key="vital_sign.id"
                              class="vital-sign d-flex align-items-center"
                            >
                              <h6 class="worksansr mb-0 pl-2">
                                {{ vital_sign.type }} -
                                {{ vital_sign.description }}
                                {{
                                  vital_sign.type == "DOR"
                                    ? `(${handleDescriptionAche(
                                        vital_sign.description
                                      )})`
                                    : vital_sign.abbreviation
                                }}
                                - ({{ formatDate(vital_sign.created_at) }})
                              </h6>
                            </div>
                          </div>
                          <div
                            class="col-md-6 pr-5 d-flex justify-content-center align-items-center"
                          >
                            <h6 class="signature text-center">
                              {{
                                professionalClassCouncilValue({
                                  id: item.user_professional_class_council_id,
                                  name: item.user_name,
                                  profile: item.user_profile_name,
                                  cpf: item.user_cpf,
                                  office: item.user_office,
                                  value:
                                    item.user_professional_class_council_value,
                                })
                              }}
                              <br />
                              <span v-if="item.certificate">
                                Certificado:
                              </span>
                              {{ item.certificate ? item.certificate : "" }}
                            </h6>
                            <h6
                              class="worksansr pl-5 pr-2"
                              v-if="item.vital_signs.length > 0"
                            >
                              {{ formatDate(item.created_at, false) }}
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </table>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="col-xl-12">
          <v-btn
            v-if="!loading"
            class="btn-print float-right"
            v-on:click="printOut"
            ><i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR</v-btn
          >
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import ErrorsMessages from "../../../../Components/ErrorsMessages";

import api from "../../../../../services/api";

import {
  generateId,
  formatDate,
  professionalClassCouncilValue,
} from "../../../../../lib/format";

import routes from "../../../../../routes";

import { userData } from "../../../../../lib/functions";

import { getAge } from "../../../../../lib/getAgeByDate";

export default {
  name: "Report",
  components: {
    ErrorsMessages,
  },
  data() {
    return {
      id: "",
      errors: [],
      cares: [],
      care_ids: [],
      resident: {},
      rest_home_name: "",
      rest_home_fantasy_name: "",
      rest_home_logo_url: null,
      logo: null,
      loading: true,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    getAge,
    generateId,
    formatDate,
    professionalClassCouncilValue,
    handleDescriptionAche(nivel) {
      if (parseInt(nivel) == 0) {
        return "SEM DOR";
      } else if (parseInt(nivel) >= 1 && parseInt(nivel) <= 3) {
        return "DOR LEVE";
      } else if (parseInt(nivel) >= 4 && parseInt(nivel) <= 7) {
        return "DOR MODERADA";
      } else if (parseInt(nivel) >= 8 && parseInt(nivel) <= 10) {
        return "DOR INTENSA";
      }
    },
    async retrieve() {
      const { care_ids } = routes.history.current.params;

      const { user, logo } = userData();

      this.rest_home_name = user.rest_home_name;
      this.rest_home_fantasy_name = user.rest_home_fantasy_name;
      this.rest_home_logo_url = user.logo_url;
      this.logo = logo;

      this.care_ids = care_ids.split(",");

      await this.get();
    },
    async get() {
      try {
        this.loading = true;

        const { care_ids } = this;

        var params = {
          care_ids,
        };

        const response = await api.get("/rest-home/report/vital-signs/report", {
          params,
        });

        const { error, errors, resident, cares } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.resident = resident;
          this.cares = cares;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    printOut() {
      window.print();
    },
  },
};
</script>

<style>
.pdf-report-vital-signs .header,
.pdf-report-vital-signs .header-space {
  height: 100px;
}
.pdf-report-vital-signs .header {
  position: fixed;
  top: 0;
}

.pdf-report-vital-signs .logo {
  height: 50px;
  object-fit: contain;
}

.pdf-report-vital-signs .rest_home_logo_url {
  height: 80px;
  width: 100%;
  object-fit: contain;
}

.pdf-report-vital-signs .resident_photo_url {
  height: 80px;
  width: 80px;
  border-radius: 50%;
  object-fit: cover;
}

.pdf-report-vital-signs table,
.pdf-report-vital-signs td,
.pdf-report-vital-signs th,
.pdf-report-vital-signs tfoot {
  width: 100% !important;
  padding: 5px;
  cursor: auto !important;
}

.pdf-report-vital-signs .signature {
  width: 100%;
  margin-top: 12px;
  border-top: solid 1px #000;
}

.pdf-report-vital-signs th {
  background-color: #f5f5f5;
}

.pdf-report-vital-signs tr span {
  font-size: 15px;
}

.pdf-report-vital-signs caption {
  font-size: x-large;
}

@media print {
  .pdf-report-vital-signs table {
    width: 100% !important;
    page-break-inside: always !important;
    border: none !important;
    margin-top: 10px !important;
  }

  .pdf-report-vital-signs .content {
    page-break-inside: avoid !important;
  }

  .pdf-report-vital-signs .content .care {
    page-break-inside: avoid !important;
  }

  .pdf-report-vital-signs .content .care .vital-sign {
    page-break-inside: avoid !important;
  }

  * {
    background: transparent !important;
    color: #000 !important;
    text-shadow: none !important;
    filter: none !important;
    -ms-filter: none !important;
  }

  body {
    margin: 0 !important;
    padding: 0 !important;
    line-height: 1.4em !important;
  }

  .pdf-report-vital-signs button {
    display: none;
  }
}
</style>